import { FC } from 'react';

import CommentItem from './CommentItem/CommentItem';
import { IComments } from './comment.interface';

const Comment: FC<IComments> = ({ comments, reviewId }) => {
  /*  const filteredComments =
    comments?.children &&
    comments.children.filter((c: any) => c.parent_id === reviewId);
  console.log(comments?.children);*/
  return (
    <>
      {comments ? (
        comments?.map((item: any) => (
          <CommentItem key={item.id} comment={item} isCommentBtn />
        ))
      ) : (
        <div></div>
      )}
    </>
  );
};

export default Comment;
